import React from 'react'
import styled from "styled-components";


const CardStyle = styled.div `

.card {
  width: 220px;
  height: 170px;
}
`

function KPSlideCard({dentistCard, right}) {
  return (
    <div className="relative w-full">
      <div className="absolute top-0 bg-primary text-white z-10 rounded-lg text-sm w-36 py-1 px-3" style={{transform: `translate(${right? "130px" : "-50px"}, -85px)`}}>High-precision 3D Scanners</div>
      <CardStyle>
      <div className="card-box min-h-min">
        <div className='card flex flex-col text-center items-center justify-center'>
          <div className="transform rounded-lg bg-white flex flex-col justify-between">
            <div className="w-full">
              <img alt='dentistCard' className="object-contain rounded-t-lg" src={dentistCard.img}></img>
            </div>
            <div className="py-4">
              <h1 className="text-secondary text-sm font-semibold text-left px-6">{dentistCard.name}</h1>
              <h1 className="text-secondary text-sm font-semibold text-left px-6">{dentistCard.title}</h1>
              <h1 className="text-secondary text-sm font-semibold text-left px-6">{dentistCard.location}</h1>
            </div>
          </div>
        </div>
      </div>
      </CardStyle>
    </div>
    
  )
}

export default KPSlideCard
